"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@mui/material/Button");
var Edit_1 = require("@mui/icons-material/Edit");
require("./btn.scss");
var EditButton = function (_a) {
    var buttonName = _a.buttonName, onClickHandler = _a.onClickHandler;
    return (React.createElement(Button_1.default, { variant: "outlined", startIcon: React.createElement(Edit_1.default, null), className: "edit-btn", onClick: onClickHandler }, buttonName));
};
exports.default = EditButton;
